import React, { FC, RefObject, useContext } from "react";
import { observer } from 'mobx-react-lite';
import { LeftPaneContext } from '../LeftPaneContext';
import { LeftPaneSelectedSection } from '../../../../constants';
import { SequenceNode } from './SequenceNode';

interface MainProgramProps {
  treeViewRef: RefObject<HTMLDivElement>;
}

export const MainProgram: FC<MainProgramProps> = observer(({treeViewRef}) => {

  const { library, selectedSection } = useContext(LeftPaneContext);
  const currentApplication = library.currentApplication;

  const initialSequence = currentApplication.initialSequence;
  const mainSequences = [initialSequence]; // we will eventually have more than ONE main sequence in phase 3
  const selectedSequence = currentApplication.currentSequence;

  return (
    <div className='sequence-container'>
      {mainSequences.map((sequence, index) => {
        const isSequenceSelected = selectedSequence?.uuid === sequence.uuid && selectedSection === LeftPaneSelectedSection.MAIN_PROGRAM;
        return <SequenceNode
          key={ index }
          sequence={ sequence }
          isSelected={ isSequenceSelected }
          isInitialSequence={ true }
          parentRef={ treeViewRef }
        />;
      })}
    </div>
  );
});
